import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { getBookingUrl } from '@/lib/booking'
import BookingModal from '@/components/BookingModal'
import { BookingContext } from '@/contexts/booking-context'

export function BookingProvider({ children }: { children: ReactNode }) {
  const url = getBookingUrl()
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)

  const openBooking = useCallback(() => setOpen(true), [])
  const value = useMemo(() => ({ openBooking }), [openBooking])

  const preload =
    Boolean(url) && !pathname.startsWith('/portal') && pathname !== '/login'

  return (
    <BookingContext.Provider value={value}>
      {children}
      {url ? (
        <BookingModal
          open={open}
          onOpenChange={setOpen}
          url={url}
          preload={preload}
        />
      ) : null}
    </BookingContext.Provider>
  )
}
